import { ROUTES_NAMES } from '@/constants';
import { beforeEnterOtpRoute } from './otpNavigationGuards';
import { RouteRecordRaw } from 'vue-router';
import OtpPanel from '@/views/OtpPanel.vue';

const otpRoute: RouteRecordRaw = {
  path: '/otp',
  name: ROUTES_NAMES.otp,
  component: OtpPanel,
  beforeEnter: beforeEnterOtpRoute
};

export default otpRoute;
